import { clearAllItems, clearSession, getItem, setItem, } from '@bigyellow/libs/storage';
import { redirect } from '@bigyellow/libs/redirect'

import { SIGNIN } from '../routes'
import { setLoggedInFlag } from '@bigyellow/libs/helpers'
import { sign_out } from '@bigyellow/api/auth'

export const signout = (store, redirect_to, reason) => {
  const notify = store ? store.get('notify') : null
  const httpClient = store ? store.get('http_client') : null;
  (async () => {
    try {
      const alreadySignedOut = await   getItem('alreadySignedOut');
      if(!alreadySignedOut)
      await sign_out(httpClient)
    } catch (err) {
      // notify && notify(err.message, { type: 'error' });
    } finally {

      setLoggedInFlag(false);
      clearSession();
      await clearAllItems();
      setItem('signout-reason', reason)
      store && store.set('user', null);
      redirect(redirect_to ?? SIGNIN)
    }

  })()

}
